import { Grid } from "@mui/material";
import { useAppDispatch, useImagePath } from "hooks";
import { useNavigate } from "react-router-dom";
import { onClosePopUp, onScrollToShopSection } from "redux/slices";
import { Avatar, Body, Button, Container, Header, Title } from "./styles";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import { useGoogleAnalyticsContext } from "contexts";
import { IPlaygamiAnalyticProps } from "interfaces/analytics/playgami";
import { useEffect } from "react";

interface GrantRewardCollectedProps {}

export const GrantRewardCollected: React.FC<GrantRewardCollectedProps> = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("local");
	const headImageUrl = getImage("/spec_dips/background.png");
	const avatarUrl = getImage("/spec_dips/pois.png");
	const scale = useCalculateScale(370 + 40, 370 + 40);
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const reportAnalytics = ({ event_name }: IPlaygamiAnalyticProps) => {
		const event_type = "grant_reward_collected_dialog";
		reportPlaygamiEvent("tp.web_frontend", {
			event_name,
			event_type,
			action: event_name,
			source: event_type
		});
	};

	const onClick = () => {
		reportAnalytics({ event_name: "continue_shopping_click" });
		dispatch(onClosePopUp());
		navigate("/shop");
		dispatch(onScrollToShopSection("Featured Deals"));
	};

	const onClose = () => {
		reportAnalytics({ event_name: "dialog_x_closed" });
		dispatch(onClosePopUp());
	};

	useEffect(() => {
		reportAnalytics({ event_name: "dialog_shown" });
	}, []);

	return (
		<Container scale={scale}>
			<CloseIconButton onClose={onClose} />
			<Header data-image={headImageUrl}>
				<Avatar src={avatarUrl} />
			</Header>
			<Body>
				<Title>Your Reward was sent to your TriPeaks Inbox</Title>
				<Grid container spacing={2}>
					<Grid
						item
						xs={12}
						/* sm={isMobile ? 6 : 12} */ display="flex"
						justifyContent="center"
					>
						<Button
							onClick={onClick}
							themeColor="secondary"
							sx={{
								minWidth: { xs: "90%" /* sm: isMobile ? "100%" : "80%" */ },
								lineHeight: 1.2
							}}
						>
							Continue Shopping
						</Button>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="grant_reward_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "80%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
